<template>
	<div>
		<h1>Információk</h1>
		<v-row>
			<v-col cols="12" sm="11">
				<v-checkbox v-model="tablazat.csakamegjelenoinfok" label="Csak a jelenleg is megjelenő infókat mutassa!"/>
			</v-col>
			<v-col cols="12" sm="1">
				<v-tooltip top>
					<template v-slot:activator="{on, attrs}">
						<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujinformaciodialogus.mutat=true"><v-icon>fa-plus</v-icon></v-btn>
					</template>
					Új információ
				</v-tooltip>
			</v-col>
		</v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-combobox
          v-model="tablazat.kereses"
          prepend-inner-icon="fa-search"
          label="Keresés"
          :items="adatok.felhasznalok.map(f =>f.nev).concat(adatok.csoportok.map(cs => cs.csoportnev).concat(adatok.szobak.map(sz => sz.szobanev+' szoba').concat(['Teljes kollégium'])))"/>
      </v-col>
    </v-row>
		<v-data-table
			:headers="tablazat.fejlecek"
			:items="tablazatsorai"
			sort-by="targy"
      v-if="adatok.informaciok"
      multi-sort
      show-group-by
      :search="tablazat.kereses"
		>
      <template v-slot:item.muveletek="{item}">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn icon v-on="on" v-bind="attrs" color="red accent-4" v-if="$store.state.minosites==-2||item.feladoid==$store.state.id" @click="torles(item.id)"><v-icon>fa-trash</v-icon></v-btn>
          </template>
          Törlés
        </v-tooltip>
      </template>

		</v-data-table>
		<v-dialog
				v-model="ujinformaciodialogus.mutat"
				persistent
				max-width="600px"
		>

				<v-card>
					<v-card-title>
						<span class="headline">Új információ</span>
					</v-card-title>
					<v-card-text>
						<v-container>
              <v-text-field
                v-model="ujinformaciodialogus.targy"
                label="Tárgy"
                prepend-inner-icon="fa-heading"/>
              <v-text-field
                prepend-inner-icon="fa-info-circle"
                v-model="ujinformaciodialogus.informacio"
                label="Információ"/>
              <v-select
                prepend-inner-icon="fa-users"
                v-model="ujinformaciodialogus.informaciomerteke"
                :items="[{ertek: 0, cim: 'Teljes kollégium'}, {ertek: 1, cim: 'Egy csoport'}, {ertek: 2, cim: 'Egy szoba'}, {ertek: 3, cim: 'Egy tanuló'}]"
                item-text="cim"
                item-value="ertek"/>
              <v-select
                v-if="adatok.csoportok&&adatok.felhasznalok&&ujinformaciodialogus.informaciomerteke>0"
                :prepend-inner-icon="ujinformaciodialogus.informaciomerteke==1?'fa-users':(ujinformaciodialogus.informaciomerteke==2?'fa-bed':'fa-user')"
                :items="ujinformaciodialogus.informaciomerteke==1?adatok.csoportok.map(cs => { return{ csoportnev: cs.csoportnev+' - Csoportvezető: '+adatok.felhasznalok.find(f => f.id==cs.csoportvezetoid).nev, id: cs.id}}): (ujinformaciodialogus.informaciomerteke==2 ? adatok.szobak: adatok.felhasznalok.filter(f => f.minosites>=0).map(f => {return {nev: f.nev+(f.csoportid?(' - '+adatok.csoportok.find(cs =>cs.id==f.csoportid).csoportnev):'')+(f.szobaid?(' - '+adatok.szobak.find(sz => sz.id==f.szobaid).szobanev+' szoba'):'')+' - '+adatok.minositesek.find(m => m.id==f.minosites).minositesnev, id: f.id}}))"
                :item-text="ujinformaciodialogus.informaciomerteke==1 ? 'csoportnev' : (ujinformaciodialogus.informaciomerteke==2 ? 'szobanev' : 'nev')"
                item-value="id"
                v-model="ujinformaciodialogus.cimzettid"
                :label="ujinformaciodialogus.informaciomerteke==1 ? 'Csoport' : (ujinformaciodialogus.informaciomerteke==2 ? 'Szoba' : 'Tanuló')"/>
              <v-menu
                v-model="ujinformaciodialogus.menuk.kezdodatum"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="ujinformaciodialogus.informaciokezdete.datum"
                    label="Információ kezdődátuma"
                    prepend-inner-icon="fa-play-circle"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ujinformaciodialogus.informaciokezdete.datum"
                  no-title
                  scrollable
                  @input="ujinformaciodialogus.menuk.kezdodatum=false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                v-model="ujinformaciodialogus.menuk.kezdoido"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="ujinformaciodialogus.informaciokezdete.ido"
                    label="Információ kezdőideje"
                    prepend-inner-icon="fa-play-circle"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  format="24hr"
                  v-if="ujinformaciodialogus.menuk.kezdoido"
                  v-model="ujinformaciodialogus.informaciokezdete.ido"
                  full-width
                  @click:minute="ujinformaciodialogus.menuk.kezdoido=false"
                ></v-time-picker>
              </v-menu>
              <v-menu
                v-model="ujinformaciodialogus.menuk.befejezodatum"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="ujinformaciodialogus.informaciovege.datum"
                    label="Információ befejeződátuma"
                    prepend-inner-icon="fa-stop-circle"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="ujinformaciodialogus.informaciovege.datum"
                  no-title
                  scrollable
                  @input="ujinformaciodialogus.menuk.befejezodatum=false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                v-model="ujinformaciodialogus.menuk.befejezoido"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="ujinformaciodialogus.informaciovege.ido"
                    label="Információ befejezőideje"
                    prepend-inner-icon="fa-stop-circle"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-time-picker
                  format="24hr"
                  v-if="ujinformaciodialogus.menuk.befejezoido"
                  v-model="ujinformaciodialogus.informaciovege.ido"
                  full-width
                  @click:minute="ujinformaciodialogus.menuk.befejezoido=false"
                ></v-time-picker>
              </v-menu>
              <v-checkbox v-model="ujinformaciodialogus.tomegeshozzaadas" label="Tömeges hozzáadás"/>
              <v-checkbox v-model="ujinformaciodialogus.mezoktorlese" label="Mezők törlése"/>
						</v-container>


					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="ujinformaciodialogus.mutat=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							v-if="ujinformaciodialogus.informaciokezdete.ido&&ujinformaciodialogus.informaciokezdete.datum&&ujinformaciodialogus.informaciovege.ido&&ujinformaciodialogus.informaciovege.datum&&ujinformaciodialogus.targy!=''&&ujinformaciodialogus.informacio!=''&&ujinformaciodialogus.informaciomerteke==0?true:ujinformaciodialogus.cimzettid>0"
							@click="ujinfo()"
						>
							Hozzáadás<v-icon>fa-plus</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card><!--Új szoba-->
		</v-dialog>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				ujinformaciodialogus: {
          tomegeshozzaadas: false,
          mezoktorlese: true,
					mutat: false,
          targy: "",
          informacio: "",
          informaciomerteke: 0,
          cimzettid: 0,
          informaciokezdete: {
            datum: new Date().toISOString().substring(0,10),
            ido: this.vezetonullak(new Date().getHours(),2)+":"+this.vezetonullak(new Date().getMinutes(),2),
          },
          informaciovege: {
            datum: new Date((new Date().setDate(new Date().getDate()+1))).toISOString().substring(0,10),
            ido: "00:00"
          },
          menuk: {
            kezdoido: false,
            kezdodatum: false,
            befejezoido: false,
            befejezodatum: false
          }
				},

				tablazat: {
          kereses: "",
          csakamegjelenoinfok: true,
					fejlecek: [
						{
							text: "Tárgy",
							value: "targy",
							align: "center",
							sortable: true,
							filterable: true,
							groupable: false
						},
            {
							text: "Információ",
							value: "informacio",
							align: "center",
							sortable: true,
							filterable: true,
							groupable: false
						},
            {
							text: "Címzett",
							value: "cimzett",
							align: "center",
							sortable: true,
							filterable: true,
							groupable: true
						},
            {
							text: "Feladó",
							value: "felado",
							align: "center",
							sortable: true,
							filterable: true,
							groupable: true
						},
            {
							text: "Információ kezdete",
							value: "informaciokezdete",
							align: "center",
							sortable: true,
							filterable: false,
							groupable: false
						},
            {
							text: "Információ vége",
							value: "informaciovege",
							align: "center",
							sortable: true,
							filterable: false,
							groupable: false
						},
            {
							text: "Műveletek",
							value: "muveletek",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
					]
				},
				adatok: {}
			}
		},
		computed: {
      tablazatsorai() {
        return this.adatok.informaciok.filter(i => this.tablazat.csakamegjelenoinfok ? new Date(Date.parse(i.informaciokezdete))<new Date()&&new Date(Date.parse(i.informaciovege))>new Date():true).map(i => {
          var szobatagjai='';
          if(i.informaciomerteke==2) this.adatok.felhasznalok.filter(f => f.szobaid==i.cimzettid).forEach(f => {szobatagjai+=f.nev+', '});
          var informaciokezdete = new Date(Date.parse(i.informaciokezdete));
          var informaciovege= new Date(Date.parse(i.informaciovege));
          return {
            id: i.id,
            targy: i.targy,
            informacio: i.informacio,
						feladoid: i.feladoid,
            felado: this.adatok.felhasznalok.find(f =>f.id==i.feladoid).nev,
            cimzett: i.informaciomerteke==0 ? 'Teljes kollégium' : (i.informaciomerteke==1?(this.adatok.csoportok.find(cs => cs.id==i.cimzettid).csoportnev+' - '+this.adatok.felhasznalok.find(f => f.id==this.adatok.csoportok.find(cs => cs.id==i.cimzettid).csoportvezetoid).nev): (i.informaciomerteke==2?(this.adatok.szobak.find(sz => sz.id==i.cimzettid).szobanev+' szoba - '+szobatagjai):this.adatok.felhasznalok.find(f => f.id==i.cimzettid).nev)),
            informaciokezdete: [informaciokezdete.getFullYear(),this.vezetonullak(informaciokezdete.getMonth()+1,2),this.vezetonullak(informaciokezdete.getDate(),2)].join('.')+'. '+[this.vezetonullak(informaciokezdete.getHours(),2), this.vezetonullak(informaciokezdete.getMinutes(),2)].join(':'),
            informaciovege: [informaciovege.getFullYear(),this.vezetonullak(informaciovege.getMonth()+1,2),this.vezetonullak(informaciovege.getDate(),2)].join('.')+'. '+[this.vezetonullak(informaciovege.getHours(),2), this.vezetonullak(informaciovege.getMinutes(),2)].join(':')
          }
          })
      }
		},
		watch: {

		},
		methods: {
      ujinfo: function() {
        var ujinformacio = {
          targy: this.ujinformaciodialogus.targy,
          informacio: this.ujinformaciodialogus.informacio,
          informaciomerteke: this.ujinformaciodialogus.informaciomerteke,
          cimzettid: this.ujinformaciodialogus.cimzettid,
          informaciokezdete: this.ujinformaciodialogus.informaciokezdete.datum+" "+this.ujinformaciodialogus.informaciokezdete.ido,
          informaciovege: this.ujinformaciodialogus.informaciovege.datum+" "+this.ujinformaciodialogus.informaciovege.ido
        };
        this.axios.post(this.$store.state.backendeleres+"informaciok/",{...ujinformacio})
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) {
                      this.adatok.informaciok.push({id: response.data.id, feladoid: this.$store.state.id, ...ujinformacio})
                      this.ujinformaciodialogus.mutat = this.ujinformaciodialogus.tomegeshozzaadas;
                      if(this.ujinformaciodialogus.mezoktorlese) {
                        this.ujinformaciodialogus.targy="";this.ujinformaciodialogus.informacio="";
                      }
											this.ujinformaciodialogus.informaciokezdete.ido=this.vezetonullak(new Date().getHours(),2)+":"+this.vezetonullak(new Date().getMinutes(),2)
                    }
                    this.snackbar.szoveg = response.data.ok ? "A hozzáadás sikeresen megtörtént!" : "A hozzáadás hibába ütközött: "+response.data.hiba;
                    this.snackbar.megnyit=true;

                  })
      },
      torles: function(id) {
        this.axios.delete(this.$store.state.backendeleres+"informaciok/"+id)
                  .then((response) => {
                    if(response.data.bejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) this.adatok.informaciok.splice(this.adatok.informaciok.findIndex(i => i.id==id),1)
                    this.snackbar.szoveg = response.data.ok ? "A törlés sikeresen megtörtént" : "A törlés hibába ütközött: "+response.data.hiba
                    this.snackbar.megnyit=true;
                  })
      },
			tablazatfrissitese: function() {
				this.axios.get(this.$store.state.backendeleres+"informaciok/")
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) this.adatok=response.data.adatok;
									})
			},
			vezetonullak: function(szam, szjegyekszama) {
	      var nulla = '';
	      for(var i = 0; i< szjegyekszama; i++) nulla+='0'
	      return (nulla + szam).slice(-szjegyekszama)
	    }
		},
		mounted(){
			this.tablazatfrissitese()
		}
	}
</script>
